import styled from "@emotion/styled";

const Styles = styled.div`
  th {
    padding: 0px 4px !important;
    text-align: center;
    word-break: break-word;
    font-size: 13px;
  }
  td {
    padding: 0px 4px !important;
    text-align: center;
    font-size: 13px;
  }
  * {
    border-color: black;
  }
  table,
  th,
  td {
    border: 1px solid black !important;
  }

  table {
    border-width: 2px;
  }
  td {
    min-height: 5mm;
  }

  table {
    border-collapse: collapse;
  }
`;
export default Styles;
